const handleDefaultResponse = (
  url: string,
  method: any,
  resolve: (value?: unknown) => void,
  reject: (reason?: any) => void
) => {
  return (response: any) => {
    const contentType = response.headers.get('Content-Type');

    if ([401, 403, 404, 409, 500, 504].includes(response.status)) {
      reject(response.status);
    } else if ([202, 205, 304].includes(response.status)) {
      resolve();
    } else if (contentType && (contentType as string).includes('json')) {
      response.json().then(resolve, reject);
    } else if (response.ok) {
      response.text().then(resolve, reject);
    } else {
      reject('Could not ' + method + url);
    }
  };
};

export const Ajax = {
  get: (url: string, options = {}) => {
    return new Promise((resolve, reject) => {
      const finalOptions = {
        ...options,
        method: 'GET'
      };
      window.fetch(url, finalOptions).then(handleDefaultResponse(url, 'GET', resolve, reject), error => {
        console.warn(`Failed to Ajax.GET ${url} from origin '${document.location.origin}': ${error.message}`);
        reject(error);
      });
    });
  },
  post: (url: string, data = {}, options = {}) => {
    return new Promise((resolve, reject) => {
      const defaultOptions = {
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' }
      };

      // @ts-ignore
      const headers = { ...defaultOptions.headers, ...options.headers };

      const opts = {
        ...defaultOptions,
        ...options,
        method: 'POST',
        headers
      };

      window.fetch(url, opts).then(handleDefaultResponse(url, 'POST', resolve, reject), error => {
        console.warn(`Failed to Ajax.POST ${url} from origin '${document.location.origin}': ${error.message}`);
        /* eslint-enable */
        reject(error);
      });
    });
  }
};
